import classNames from 'classnames'
import * as React from 'react'

import {IconAvatar} from '@/assets/specify/IconAvatar'
import {makeEditable} from '@/common/utils'
import Image from '@/components/Image'

const Author = ({picture, name, _editable, className}) => {
  return (
    <section
      {...makeEditable(_editable)}
      className={classNames(
        'misc-button-s flex h-4 flex-row items-center gap-2 uppercase not-italic text-violet-600',
        className
      )}
    >
      {picture && picture.filename ? (
        <div className='h-4 w-4'>
          <Image {...picture} ratio='1:1' sizes='16px' />
        </div>
      ) : (
        <>
          <IconAvatar aria-hidden />
        </>
      )}
      <span>•</span>
      <span>{name}</span>
    </section>
  )
}

export default Author
